import logo from './logo.svg';
import './App.css';
import Header from "./components/Header"
import Footer from "./components/Footer"
import Notes from "./components/Notes"
import Create from "./components/Create"
function App() {
  return (
    <>
      <Header />
      <Create />
      <Footer />
    </>
  );
}

export default App;
